import { Skeleton } from "@/components/ui/skeleton";

const MarketplaceCardSkeleton = () => (
  <div className="tibia-border bg-card rounded-lg overflow-hidden w-full">
    {/* Type header */}
    <div className="px-2 py-1.5 flex flex-col items-center gap-0.5">
      <Skeleton className="h-3 w-16" />
      <Skeleton className="h-2 w-20 mt-0.5" />
    </div>
    {/* Item name */}
    <div className="px-3 pt-2 h-[22px] flex items-center justify-center">
      <Skeleton className="h-3 w-24" />
    </div>
    {/* Image area */}
    <div className="relative flex items-center justify-center p-3 bg-secondary/30 h-[100px]">
      <Skeleton className="w-[62px] h-[62px] rounded" />
    </div>
    {/* Info */}
    <div className="px-3 pt-2 pb-3 h-[70px] flex flex-col justify-between">
      <div className="flex flex-col gap-1">
        <Skeleton className="h-3 w-20 mx-auto" />
        <Skeleton className="h-2 w-16 mx-auto" />
      </div>
      <Skeleton className="h-2 w-full mt-1" />
    </div>
    {/* Actions */}
    <div className="px-3 pb-2 flex justify-center gap-2">
      <Skeleton className="h-5 w-5 rounded-full" />
      <Skeleton className="h-5 w-5 rounded-full" />
      <Skeleton className="h-5 w-5 rounded-full" />
    </div>
  </div>
);

export default MarketplaceCardSkeleton;
